import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * SingleModules component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    singleModules: {
      background: variables.color.primary.white,
      height: '100%',
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%', // 'calc(100% - 1rem)',
      height: '100%',
    },

    searchBar: {
      display: 'flex',
      marginBottom: '2.4rem',
    },

    search: {
      '& .MuiInput-root': {
        border: `.1rem solid ${variables.colorV2.input.search.border.default}`,
        height: '2.8rem',
        padding: theme.spacing(0.5, 1.5),
      },
    },

    modulesList: {
      height: '100%', //'calc(100% - 4.6rem)',
      paddingRight: '5px',
      overflowY: 'auto',

      '& > div:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },

    draggableCard: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '.8rem',
      marginBottom: theme.spacing(1),
    },

    loaderBlock: {
      marginBottom: '20px',
    },

    // SearchFilterSortUpload style overrides
    sfsuContainer: {
      '&&': {
        // alignItems: 'normal',
        width: '100%',
      },
    },

    sfsuSearchBar: {
      '&&': {
        height: '2.8rem',
        marginLeft: '0',
        width: '100%',
        zIndex: 1,
        '& input': {
          height: '2.6rem',
        },
      },
      '& > div > div': {
        borderColor: variables.colorV2.input.search.border.default + ' !important',
      },
    },

    sfsuFilterSort: {
      // marginRight: '1.6rem',
      '&&': {
        '& button': {
          borderColor: variables.colorV2.input.search.border.default,
          borderRadius: '2.6rem',
          height: '2.6rem',
          minWidth: '2.6rem',
          width: '2.6rem',

          '& svg path': {
            fill: variables.colorV2.input.default.icon.fill.default,
          },
        },
      },
    },
  }),
);
